import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { useAuth } from "@/context/AuthContext";
import { signature } from "@/components/ShareDialog";
import { api, errMsg } from "@/lib/api";

const cls = "mt-1 w-full rounded-md border border-[#D4E6EC] px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#0B6E8F]/30";

export function ProfileDialog({ open, onOpenChange }) {
  const { user, setUser } = useAuth();
  const [f, setF] = useState({ name: "", title: "", phone: "" });
  useEffect(() => {
    if (open && user) setF({ name: user.name || "", title: user.title || "", phone: user.phone || "" });
  }, [open, user]);
  const save = async () => {
    try {
      const r = await api.patch("/auth/me", f);
      setUser(r.data);
      toast.success("Firma aggiornata");
      onOpenChange(false);
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="profile-dialog">
        <DialogHeader><DialogTitle className="font-serif-it text-2xl">La tua firma nei messaggi</DialogTitle></DialogHeader>
        <label className="block text-xs font-medium text-[#47606B]">Nome e cognome<input className={cls} value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} data-testid="profile-name" /></label>
        <label className="block text-xs font-medium text-[#47606B]">Ruolo<input className={cls} placeholder="es. Responsabile eventi" value={f.title} onChange={(e) => setF({ ...f, title: e.target.value })} data-testid="profile-title" /></label>
        <label className="block text-xs font-medium text-[#47606B]">Telefono<input className={cls} placeholder="es. +39 333 1234567" value={f.phone} onChange={(e) => setF({ ...f, phone: e.target.value })} data-testid="profile-phone" /></label>
        <div className="rounded-md bg-[#EAF5F7] p-3 text-xs whitespace-pre-line text-[#47606B]" data-testid="profile-preview">{signature(f)}</div>
        <DialogFooter><Button onClick={save} data-testid="profile-save">Salva</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
